import { createStoreModule } from '@/_core/fluxstore';
import { IAction } from '@/_core/fluxstore/types';
import { StorymapState } from './types';

const initState = () => {
    return new StorymapState();
};

export const useStorymapStore = createStoreModule<StorymapState, IAction<StorymapState>>(initState, 'storymap');
